
<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/equipment/maintain/template/item/page"
			getKey="rows" :columns="columns">
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzengbaoyangmingxi',null,'50%')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			
			
			<template #baoyangzhouqi="scope">
				 <p v-if="scope.row.cycleType==2">
					{{$t(store.state.dictJson['EQUIPMENT_MAINTAIN_TEMPLATE_MODE'][scope.row.maintainType])}}: 1{{$t('ci')}}/{{scope.row.cycleValue}}个{{$t(store.state.dictJson['CYCLE_TYPE'][scope.row.cycleType])}}
				 </p>
				 <p v-else>
				 	{{$t(store.state.dictJson['EQUIPMENT_MAINTAIN_TEMPLATE_MODE'][scope.row.maintainType])}}: 1{{$t('ci')}}/{{scope.row.cycleValue}}{{$t(store.state.dictJson['CYCLE_TYPE'][scope.row.cycleType])}}
				  </p>
			</template>
			
			
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'w2');saveCycle()">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/maintain/template/item/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzengbaoyangmingxi'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('baoyangbuwei')" required="required">
						<el-input v-model="yt.editObj.part"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangneirong')" required="required">
						<el-input v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input v-model="yt.editObj.attention"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangzhouqi')" required="required">
						<el-input readonly="true" @focus="showCycleDialog()" v-model="yt.editObj.cycle"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/equipment/maintain/template/item/create',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('baoyangbuwei')" required="required">
						<el-input v-model="yt.editObj.part" disabled="true"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangneirong')" required="required">
						<el-input v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input v-model="yt.editObj.attention"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangzhouqi')" required="required">
						<el-input readonly="true" @focus="showCycleDialog()" v-model="yt.editObj.cycle"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/equipment/maintain/template/item/update',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 保养周期 -->
			<template v-if="yt.editObj.action == 'baoyangzhouqi'">
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.req('POST','/web/equipment/maintain/template/item/create',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
				</span>
			</template>
		</el-dialog>
		<el-dialog :show-close="true" :title="$t('baoyangzhouqi')" :visible.sync="isShowCycleDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<el-form :inline="true" ref="cycleForm" size="mini" :label-width="yt.formLabelWidth">
				<!-- 保养类型 (字典) -->
				<el-form-item :label="$t('baoyangleixing')" required="required" label-width="120px" size="mini">
					<yi_dictionary_select :type="'EQUIPMENT_MAINTAIN_TEMPLATE_MODE'" :ids.sync="yt.editObj.maintainType">
					</yi_dictionary_select>
				</el-form-item>
			</el-form>
			<el-form ref="cycleForm" size="mini" :label-width="yt.formLabelWidth">
				<!-- 周期 -->
				<el-form-item :label="$t('zhouqi')+'  1/'+$t('ci')" required="required" label-width="125px" size="mini" >
					<div style="display: flex;">
						<yi_number_input :min="1" :type="number" :start.sync="yt.editObj.cycleValue"></yi_number_input>
						<el-col :span="0.95">&nbsp;</el-col>
						<el-select size="mini" v-model="yt.editObj.cycleType" style="width: 20px;">
							<el-option :label="$t('nian')" :value="1"></el-option>
							<el-option :label="$t('yue')" :value="2"></el-option>
							<el-option :label="$t('zhou')" :value="3"></el-option>
							<el-option :label="$t('tian')" :value="4"></el-option>
						</el-select>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="resetForm();closeCycleDialog()">{{$t("quxiao")}}</el-button>
				<el-button :loading="store.state.global_loading" size="mini" @click="saveCycle()" type="primary">
					{{ $t("baocun") }}
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	// import curd_data from '@/common/curd/curd_data';
	export default {
		/* 唯一命名 */
		name: 'admin_data_template_equipment_maintenance_item',
		data() {
			return {
				columns: [{
					label: 'baoyangbuwei',
					prop: 'part',
					width: 130,
				}, {
					label: 'baoyangneirong',
					prop: 'content',
					width: 330,
				}, {
					label: 'zhuyishixiang',
					prop: 'attention',
				}, {
					label: 'baoyangzhouqi',
					type:'slot'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 150,
					fixed: 'right'
				}],
				isShowCycleDialog: false,
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
					maintainTemplateId: this.$attrs.maintainTemplate.id,
				}
				this.yt.get(1);
			}, 300)
		},
		methods: {
			beforeAdd(params, url) {
				params.maintainTemplateId = this.$attrs.maintainTemplate.id
				return params
			},
			showCycleDialog(){
				this.isShowCycleDialog = true;
			},
			saveCycle(){
				if(this.yt.editObj.maintainType==undefined){
					this.yt.editObj.maintainType = 1;
				}
				this.isShowCycleDialog = false;
				let label = '';
				if(this.yt.editObj.cycleValue==undefined){
					this.yt.editObj.cycleValue = 1;
				}
				label = '1'+this.$t('ci')+"/"+this.yt.editObj.cycleValue
				console.log("type:",this.yt.editObj.cycleValue)
				if(this.yt.editObj.cycleType==1){
					label = label+this.$t('nian')
				}
				if(this.yt.editObj.cycleType==2){
					label = label+this.$t('ge')+this.$t('yue')
				}
				if(this.yt.editObj.cycleType==3){
					label = label+this.$t('zhou')
				}
				if(this.yt.editObj.cycleType==4){
					label = label+this.$t('tian')
				}
				console.log('label:',label);
				this.$set(this.yt.editObj, 'cycle', label)
			},
			closeCycleDialog(){
				this.isShowCycleDialog = false;
			},
			// todo 后续完善周期弹窗表单取消清除
			resetForm(){
				// this.yt.editObj.maintainType = null
				// this.yt.editObj.cycleValue = 0
				// this.yt.editObj.cycleType = null
				 // this.$set(this.yt.editObj,'maintainType','');
			}

		}
	};
</script>


<style scoped lang="scss">W
	.shift {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
	}
</style>
